import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Select from "react-select";

import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Button,
    Form,
    Input,
} from "reactstrap";

import { getAllProperties, addMonthUpdate } from "service/api";
import AdminGuard from "helpers/AuthType/AdminGuard";

const AddMonthUpdate = () => {
    const [rows1, setRows1] = useState([{ id: 1, description: "", url: "" }]);
    const [images, setImages] = useState([]);
    const [refreshTable, setRefreshTable] = useState(false);
    const [Property, setProperty] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState(null);
    const [month, setMonth] = useState("");

    useEffect(() => {
        getProperty();
    }, []);

    const getProperty = async () => {
        let response = await getAllProperties();
        setProperty(response.properties);
    };

    const propertyOptions = Property.map((property) => ({
        value: property.id,
        label: property.title,
    }));

    const handleAddRowNested = () => {
        setRows1([
            ...rows1,
            { id: rows1.length + 1, description: "", url: "" },
        ]);
    };

    const handleRemoveRow = (id) => {
        if (rows1.length > 1) {
            setRows1(rows1.filter((row) => row.id !== id));
            setImages(images.filter((_, idx) => rows1[idx].id !== id));
        }
    };

    const handleRowChange = (index, field, value) => {
        const updatedRows = [...rows1];
        updatedRows[index][field] = value;
        setRows1(updatedRows);
    };

    const onFileChange = (e, index) => {
        const file = e.target.files[0];
        if (file) {
            const updatedImages = [...images];
            updatedImages[index] = file;
            setImages(updatedImages);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selectedProperty) {
            toast.error("Please select a property.");
            return;
        }

        if (!month) {
            toast.error("Please select a month.");
            return;
        }

        const base64Images = await Promise.all(imagePromises);



        const payload = {
            propertyId: selectedProperty.value,
            month: month,
            updates: rows1.map((row, index) => ({
                description: row.description,
                url: row.url,
                imageBase64: base64Images[index], // send as base64
                imageName: images[index]?.name || ""
            })),
        };

        try {
            const res = await addMonthUpdate(payload);

            if (
                res.data &&
                res.data.message ===
                "An update already exists for this property in the specified month"
            ) {
                const [year, monthNum] = month.split("-");
                const monthName = new Date(`${year}-${monthNum}-01`).toLocaleString("default", { month: "long" });
                toast.error(`Update already exists for ${selectedProperty.label} in ${monthName} ${year}`);
                return;
            }

            toast.success("Month update added successfully!");
            setRefreshTable((prev) => !prev);
            setRows1([{ id: 1, description: "", url: "" }]);
            setImages([]);
            setSelectedProperty(null);
            setMonth("");
        } catch (error) {
            toast.error("Something went wrong!");
            console.error(error);
        }
    };

    return (
        <AdminGuard>
            <React.Fragment>
                <div
                    className="page-content"
                    style={{
                        color: "#fff",
                        fontFamily: "'Roboto', sans-serif",
                        minHeight: "100vh",
                        background: "#0B132B",
                        paddingTop: "30px",
                        paddingBottom: "30px",
                    }}
                >

                    <Container fluid={true}>
                        <Row className="justify-content-center">
                            <Col xl={8} lg={10} md={12}>
                                <Card
                                    style={{
                                        marginTop: "80px",
                                        background: "#1C2541",
                                        border: "1px solid rgba(255, 255, 255, 0.2)",
                                        borderRadius: "15px",
                                        boxShadow: "0 4px 30px rgba(0, 0, 0, 0.3)",
                                    }}
                                >

                                    <CardBody>
                                        <CardTitle
                                            className="mb-4 text-center"
                                            style={{ fontSize: "1.8rem", fontWeight: "600" }}
                                        >
                                            Add Monthly Updates
                                        </CardTitle>
                                        <Form encType="multipart/form-data" onSubmit={handleSubmit}>
                                            <Row>
                                                <Col md={12}>
                                                    <div className="mb-3">
                                                        <Select
                                                            options={propertyOptions}
                                                            placeholder="Select Completed Projects"
                                                            value={selectedProperty}
                                                            onChange={setSelectedProperty}
                                                            styles={{
                                                                control: (base) => ({
                                                                    ...base,
                                                                    backgroundColor: "#fff",
                                                                    color: "#000",
                                                                    borderRadius: "8px",
                                                                }),
                                                                input: (base) => ({
                                                                    ...base,
                                                                    color: "#000",
                                                                }),
                                                                placeholder: (base) => ({
                                                                    ...base,
                                                                    color: "#666",
                                                                }),
                                                                singleValue: (base) => ({
                                                                    ...base,
                                                                    color: "#000",
                                                                }),
                                                                menu: (base) => ({
                                                                    ...base,
                                                                    backgroundColor: "#fff",
                                                                }),
                                                                option: (base, state) => ({
                                                                    ...base,
                                                                    backgroundColor: state.isFocused
                                                                        ? "#f0f0f0"
                                                                        : "#fff",
                                                                    color: "#000",
                                                                }),
                                                            }}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col md={12} className="mb-3">
                                                    <Label>Month</Label>
                                                    <Input
                                                        type="month"
                                                        name="month"
                                                        value={month}
                                                        onChange={(e) => setMonth(e.target.value)}
                                                        className="form-control"
                                                        style={{
                                                            backgroundColor: "rgba(255, 255, 255, 0.3)",
                                                            color: "#fff",
                                                            border: "1px solid rgba(255,255,255,0.4)",
                                                        }}
                                                    />
                                                </Col>

                                                <div className="inner-repeater mb-4 w-100">
                                                    <table style={{ width: "100%" }}>
                                                        <tbody>
                                                            {rows1.map((formRow, index) => (
                                                                <tr key={formRow.id}>
                                                                    <td>
                                                                        <Row className="align-items-end mb-4">
                                                                            <Col md="6" className="mb-3">
                                                                                <Label>Description</Label>
                                                                                <Input
                                                                                    type="textarea"
                                                                                    name={`description-${index}`}
                                                                                    value={formRow.description}
                                                                                    onChange={(e) =>
                                                                                        handleRowChange(
                                                                                            index,
                                                                                            "description",
                                                                                            e.target.value
                                                                                        )
                                                                                    }
                                                                                    className="inner form-control"
                                                                                    placeholder="Enter description..."
                                                                                    style={{
                                                                                        backgroundColor:
                                                                                            "rgba(255, 255, 255, 0.3)",
                                                                                        color: "#fff",
                                                                                        border:
                                                                                            "1px solid rgba(255,255,255,0.4)",
                                                                                    }}
                                                                                />
                                                                            </Col>
                                                                            <Col md="6" className="mb-3">
                                                                                <Label>URL</Label>
                                                                                <Input
                                                                                    type="text"
                                                                                    name={`urls-${index}`}
                                                                                    value={formRow.url}
                                                                                    onChange={(e) =>
                                                                                        handleRowChange(
                                                                                            index,
                                                                                            "url",
                                                                                            e.target.value
                                                                                        )
                                                                                    }
                                                                                    className="inner form-control"
                                                                                    placeholder="Enter URLs..."
                                                                                    style={{
                                                                                        backgroundColor:
                                                                                            "rgba(255, 255, 255, 0.3)",
                                                                                        color: "#fff",
                                                                                        border:
                                                                                            "1px solid rgba(255,255,255,0.4)",
                                                                                    }}
                                                                                />
                                                                            </Col>
                                                                            <Col md="6" className="mb-3">
                                                                                <Label>Upload Image</Label>
                                                                                <Input
                                                                                    type="file"
                                                                                    name={`img-${index}`}
                                                                                    onChange={(e) =>
                                                                                        onFileChange(e, index)
                                                                                    }
                                                                                    className="inner form-control"
                                                                                    style={{
                                                                                        backgroundColor:
                                                                                            "rgba(255, 255, 255, 0.3)",
                                                                                        color: "#fff",
                                                                                        border:
                                                                                            "1px solid rgba(255,255,255,0.4)",
                                                                                    }}
                                                                                    accept="image/*"
                                                                                    required
                                                                                />
                                                                                {images[index] && (
                                                                                    <div className="mt-2">
                                                                                        <small>
                                                                                            Selected: {images[index].name}
                                                                                        </small>
                                                                                    </div>
                                                                                )}
                                                                            </Col>
                                                                            <Col md="2" className="mb-3">
                                                                                {index !== 0 && (
                                                                                    <Button
                                                                                        color="danger"
                                                                                        className="w-100"
                                                                                        onClick={() =>
                                                                                            handleRemoveRow(formRow.id)
                                                                                        }
                                                                                    >
                                                                                        <i className="bx bx-trash"></i>
                                                                                    </Button>
                                                                                )}
                                                                            </Col>
                                                                        </Row>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                    <Button
                                                        onClick={handleAddRowNested}
                                                        color="success"
                                                        className="mt-2"
                                                        type="button"
                                                    >
                                                        + Add More
                                                    </Button>
                                                </div>
                                            </Row>

                                            <div className="text-center">
                                                <button
                                                    type="submit"
                                                    style={{
                                                        width: "100%",
                                                        fontWeight: "600",
                                                        background:
                                                            "linear-gradient(to right, #6a11cb, #2575fc)",
                                                        border: "none",
                                                        padding: "12px 20px",
                                                        borderRadius: "25px",
                                                        fontSize: "16px",
                                                    }}
                                                >
                                                    Send
                                                </button>
                                            </div>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        </AdminGuard>
    );
};

export default AddMonthUpdate;
